import React, { useState, useEffect, useRef } from "react";
import "./RecWiseCode.css";
import { useNavigate } from 'react-router-dom';
import CTA from './CTA';

const BenefitsAdministrationModule = () => {
  const [activeSection, setActiveSection] = useState("benefits-enrollment");
  const [visibleSections, setVisibleSections] = useState(new Set());
  const sectionsRef = useRef({});
  const navigate = useNavigate();
  const handleBenefits = () => navigate('/access-recruit');

  const sectionContent = {
    "benefits-enrollment": {
      title: "Automated Benefits",
      description: "Streamline benefits enrollment with guided workflows, eligibility checks,and automated plan assignments. Employees can compare plans, enroll through self-service, and receive instant confirmation. Enrollment windows, life events, and reminders are managed automatically."
    },
    "plan-management": {
      title: "Comprehensive Management",
      description: "Manage health, retirement, and voluntary benefits from one centralized platform. Configure coverage, premiums, eligibility, and enrollment rules while tracking costs, participation, and renewals all with minimal disruptionManage health, retirement, and voluntary benefits from one centralized platform. Configure coverage, premiums, eligibility, and enrollment rules while tracking costs, participation, and renewals all with minimal disruption"
    },
    "carrier-integration": {
      title: "Carrier Integration",
      description: "Securely automate data exchange with insurance carriers and benefits providers. Sync enrollments, eligibility, premiums, and coverage updates with built-in validation and error handling for accurate, real-time benefits administration."
    },
    "cost-management": {
      title: "Benefits Cost Management",
      description: "Track and control benefits spending with real-time budgets, forecasts, and cost analysis. Monitor employer and employee contributions, identify trends, and optimize plan design to maximize ROI."
    },
    "employee-self-service": {
      title: "Benefits Self-Service Portal",
      description: "Give employees easy access to their benefits through a secure, intuitive portal. They can view plans, update dependents, manage life events, review claims, and compare options all without HR assistance."
    }
  };

  const sections = [
    { id: "benefits-enrollment", label: "ENROLLMENT" },
    { id: "plan-management", label: "PLAN MGMT" },
    { id: "carrier-integration", label: "INTEGRATION" },
    { id: "cost-management", label: "COST MGMT" },
    { id: "employee-self-service", label: "SELF-SERVICE" }
  ];

  useEffect(() => {
    const onScroll = () => {
      const pos = window.scrollY + 150;
      for (const sec of sections) {
        const el = sectionsRef.current[sec.id];
        if (!el) continue;
        if (pos >= el.offsetTop && pos < el.offsetTop + el.offsetHeight) {
          setActiveSection(sec.id);
          break;
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            setVisibleSections((prev) => new Set([...prev, en.target.dataset.section]));
          }
        });
      },
      { threshold: 0.15 }
    );
    Object.values(sectionsRef.current).forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const scrollToSection = (id) => {
    const el = sectionsRef.current[id];
    if (el) window.scrollTo({ top: el.offsetTop - 100, behavior: "smooth" });
  };

  return (
    <div className="resto-main-wrapper">
      {/* <nav className="resto-sticky-navbar">
        <div className="resto-nav-container">
          {sections.map((s) => (
            <button
              key={s.id}
              className={`resto-nav-button ${activeSection === s.id ? "resto-active" : ""}`}
              onClick={() => scrollToSection(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </nav> */}

      <div className="resto-content-wrapper">

        {/* 1. Benefits Enrollment */}
        <section
          ref={(el) => (sectionsRef.current["benefits-enrollment"] = el)}
          data-section="benefits-enrollment"
          className={`resto-section ${visibleSections.has("benefits-enrollment") ? "resto-visible" : ""}`}
        >
          <div className="resto-section-content resto-fade-in-left">
            <div className="resto-section-label">Enrollment</div>
            <h2 className="resto-section-title">
              {sectionContent["benefits-enrollment"].title}
            </h2>
            <p className="resto-section-description">
              {sectionContent["benefits-enrollment"].description}
            </p>

            <div className="resto-buttons-group">
              <button className="resto-primary-btn" onClick={handleBenefits}>Start Enrollment</button>
              <button className="resto-secondary-btn" onClick={handleBenefits}>Track Participation</button>
            </div>
          </div>

          <div className="resto-section-image resto-fade-in-right">
            <img src="/images/beds_1.png" className="resto-real-image" alt="Benefits Enrollment" />
          </div>
        </section>

        {/* 2. Plan Management */}
        <section
          ref={(el) => (sectionsRef.current["plan-management"] = el)}
          data-section="plan-management"
          className={`resto-section resto-reverse ${visibleSections.has("plan-management") ? "resto-visible" : ""}`}
        >
          <div className="resto-section-content resto-fade-in-right">
            <div className="resto-section-label">Plans</div>
            <h2 className="resto-section-title">
              {sectionContent["plan-management"].title}
            </h2>
            <p className="resto-section-description">
              {sectionContent["plan-management"].description}
            </p>

            <div className="resto-buttons-group">
              <button className="resto-primary-btn" onClick={handleBenefits}>Manage Plans</button>
              <button className="resto-secondary-btn" onClick={handleBenefits}>Configure Options</button>
            </div>
          </div>

          <div className="resto-section-image resto-fade-in-left">
             <img src="/images/beds_2.png" className="resto-real-image" alt="Plan Management" />
          </div>
        </section>

        <CTA/>

        {/* 3. Carrier Integration */}
        <section
          ref={(el) => (sectionsRef.current["carrier-integration"] = el)}
          data-section="carrier-integration"
          className={`resto-section ${visibleSections.has("carrier-integration") ? "resto-visible" : ""}`}
        >
          <div className="resto-section-content resto-fade-in-left">
            <div className="resto-section-label">Integration</div>
            <h2 className="resto-section-title">
              {sectionContent["carrier-integration"].title}
            </h2>
            <p className="resto-section-description">
              {sectionContent["carrier-integration"].description}
            </p>

            <div className="resto-buttons-group">
              <button className="resto-primary-btn" onClick={handleBenefits}>Configure Integrations</button>
              <button className="resto-secondary-btn" onClick={handleBenefits}>Monitor Data Exchange</button>
            </div>
          </div>

          <div className="resto-section-image resto-fade-in-right">
             <img src="/images/beds_3.png" className="resto-real-image" alt="Carrier Integration" />
          </div>
        </section>

        {/* 4. Cost Management */}
        <section
          ref={(el) => (sectionsRef.current["cost-management"] = el)}
          data-section="cost-management"
          className={`resto-section resto-reverse ${visibleSections.has("cost-management") ? "resto-visible" : ""}`}
        >
          <div className="resto-section-content resto-fade-in-right">
            <div className="resto-section-label">Cost Management</div>
            <h2 className="resto-section-title">
              {sectionContent["cost-management"].title}
            </h2>
            <p className="resto-section-description">
              {sectionContent["cost-management"].description}
            </p>

            <div className="resto-buttons-group">
              <button className="resto-primary-btn" onClick={handleBenefits}>Analyze Costs</button>
              <button className="resto-secondary-btn" onClick={handleBenefits}>Budget Planning</button>
            </div>
          </div>

          <div className="resto-section-image resto-fade-in-left">
             <img src="/images/beds_4.png" className="resto-real-image" alt="Cost Management" />
          </div>
        </section>

        {/* 5. Employee Self-Service */}
        <section
          ref={(el) => (sectionsRef.current["employee-self-service"] = el)}
          data-section="employee-self-service"
          className={`resto-section ${visibleSections.has("employee-self-service") ? "resto-visible" : ""}`}
        >
          <div className="resto-section-content resto-fade-in-left">
            <div className="resto-section-label">Self-Service</div>
            <h2 className="resto-section-title">
              {sectionContent["employee-self-service"].title}
            </h2>
            <p className="resto-section-description">
              {sectionContent["employee-self-service"].description}
            </p>

            <div className="resto-buttons-group">
              <button className="resto-primary-btn" onClick={handleBenefits}>Access Portal</button>
              <button className="resto-secondary-btn" onClick={handleBenefits}>View Benefits</button>
            </div>
          </div>

          <div className="resto-section-image resto-fade-in-right">
            <img src="/images/beds_5.png" className="resto-real-image" alt="Employee Self-Service" />
          </div>
        </section>

      </div>
    </div>
  );
};

export default BenefitsAdministrationModule;